
//*******************************
//* don't change this file
//* this file is auto generated
//*******************************

export const environment = {
  production: false,
  baseUrl: 'https://obo-nlp.covid-stage.obodroid.app',
  auth: {
    loginUrl: 'https://obo-auth.covid-stage.obodroid.app',
    clientId: 'user-zbx9gcwrjf9un2j8',
    redirectUri: 'https://obo-cms.covid-stage.obodroid.app/callback'
  },
};
